import { DataGrid, GridColDef, GridRenderCellParams, useGridApiRef } from "@mui/x-data-grid";
import React from "react";
import { PropsLabelMatches } from "../components/Anotador";
import { ANNOTATOR_SHOW_LEFT_CONTEXT, ANNOTATOR_SHOW_RIGHT_CONTEXT } from "../tools/Contants";
import { basicFormatString, removeRelatedAnnotationsKeepOne, removeSpecialCharacters } from "../tools/Utils";
import { Height } from "@mui/icons-material";

export default function LabelMatches(props: PropsLabelMatches){

    const apiRef = useGridApiRef();
    const columns: GridColDef[] = [
        {field: 'id', width: 1},
        {field: 'Left Context', flex: 0.3, minWidth: 200,
            renderCell: (params: GridRenderCellParams<any, number>) => 
            (
                <div>
                    {
                      handleShowContext(params,ANNOTATOR_SHOW_LEFT_CONTEXT)
                    }
                </div>
            )},
        {field: 'Placename', width: 70, renderCell: (params: GridRenderCellParams<any, number>) => 
            (
                <div>
                    {
                      (params.row.relatedTo === -1)?params.row.text:params.row.relatedText
                    }
                </div>
            )},
        {field: 'Right Context', flex: 0.3, minWidth: 200,
            renderCell: (params: GridRenderCellParams<any, number>) => 
            (
                <div>
                    {
                      handleShowContext(params,ANNOTATOR_SHOW_RIGHT_CONTEXT)
                    }
                </div>
            )}
    ];


    const handleShowContext = (params: any, contextType: string):String =>{
        var context = '';
        
        var nextParagraphContent = '';
        
        if(params.row.relatedTo !== -1 && params.row.start > 0){
            var paragraphData = params.row.paragraph.split('p');
            var nextParagraph = 's1p'+(parseInt(paragraphData[1])+1);
            nextParagraphContent = getParagraphContext(nextParagraph);
        }


        var paragraphContent = getParagraphContext(params.row.paragraph);
        var textSize:number = (params.row.relatedTo === -1)?params.row.text.length:params.row.relatedText.substring(params.row.text.length,params.row.relatedText.length).length;



        if(contextType === ANNOTATOR_SHOW_RIGHT_CONTEXT){
            if(params.row.relatedTo === -1){
                context = getRightContext(paragraphContent, params.row.start, textSize);
            }
            else{
                context = getRightContext(nextParagraphContent,0,textSize);
            }
        }else
        {
            context = getLeftContext(params,paragraphContent, params.row.start);
        }

        return context;
    }

    const getParagraphContext = (paragraph:string):string =>{
        var paragraphElement = document.getElementById(paragraph);
        if(paragraphElement)
        {
            return paragraphElement.innerText;
        }else{
            return '';
        }
           
    }

    const getLeftContext = (params:any,paragraphContent: string, index: number):string =>{
         var leftContextComplete = removeSpecialCharacters(paragraphContent).substring(0,index );
         const wordList = leftContextComplete.trim().split(' ');
         const lastWord = wordList.at(-1);
         const text =  (params.row.relatedTo === -1)?params.row.text:params.row.relatedText;
         if(text.startsWith(lastWord))
         {//para evitar error de split con caracteres especiales se remuve el ultimo si se inicia el texto anotado con el ultimo
            return wordList.slice(-4).slice(0,3).join(' ');
         }else
         {//si no inicia el texto anotado con el ultimo elemento se toman los tres ultimos de forma normal
            return wordList.slice(-3).join(' ');
         }
        
    }

    const getRightContext = (paragraphContent: string, index: number, annotationSize:number):string =>{

       
        var rightContextComplete = paragraphContent.substring((index + annotationSize), paragraphContent.length);
        const firstThreeWords = rightContextComplete.trim().split(' ').slice(0, 3);
        return firstThreeWords.join(' ');
    }
    const handleOnCellClick = (params: any) => {
    // Access data from the clicked cell
    props.onScroll(params.id);
  };

      return (
        <div style={{height: '100%'}}>
                    <DataGrid apiRef={apiRef} initialState={{columns:{columnVisibilityModel:{ id: false}},pagination: {paginationModel: {pageSize: 10}}}} rows={removeRelatedAnnotationsKeepOne(props.matches)} columns={columns} onCellClick={handleOnCellClick} pageSizeOptions={[5,10,30,50]} rowHeight={25}  
                    columnHeaderHeight={40}
                    density="comfortable"
                     ></DataGrid>
        </div>
        
    );
}